import { gql } from "@apollo/client";

export const propertyFragment = gql(/* GraphQL */ `
  fragment PropertyFragment on Property {
    mandatory
    datatype
    code
    name
    businessType
    constraints {
      code
      description
      dataType
      value
      message
    }
  }
`);
